import { IChildrenProp } from "types/components/components.interface";
import "./TableMessage.scss";
import { HTMLAttributes } from "react";

export interface ITableMessageProps
  extends IChildrenProp,
    HTMLAttributes<HTMLTableRowElement> {
  disable?: boolean;
  isAdd?: boolean;
  emptyMessage?: boolean;
  tdClassName?: string;
}

const TableMessage = ({
  children,
  disable,
  onClick,
  isAdd = true,
  emptyMessage = false,
  tdClassName,
  ...props
}: ITableMessageProps) => {
  return (
    <tr
      {...props}
      onClick={(e) => !disable && onClick && onClick(e)}
      className={`table-message ${disable ? "disable" : ""} ${
        isAdd ? "is-add" : ""
      } ${emptyMessage ? "is-empty" : ""} ${props.className ?? ""}`}
    >
      <td className="td table-message-content">{children}</td>
    </tr>
  );
};

export default TableMessage;
